<template>
  <!-- 线上 -->
  <div v-if="formData" class="main-container">
    <Form ref="form" class="page-form" :model="formData" :label-width="120" :disabled="reqUrl == 'read/detail'">
      <!-- 保单归属 -->
      <fromTo :formData="formData" :disabled="reqUrl == 'read/detail'"></fromTo>

      <!-- 保单信息 -->
      <detail
        ref="detail"
        :disabled="reqUrl == 'read/detail'"
        :formData="formData"
        :companyList="companyList"
        :themeList="themeList"
        :policyStatus="policyStatus"
      ></detail>

      <!-- 保费优惠及预缴信息 -->
      <policyDiscount ref="policyDiscount" :formData="formData" :disabled="reqUrl == 'read/detail'" />

      <template v-if="$units.isSelfOrg(formData)">
        <!-- 投保人 -->
        <holder :disabled="reqUrl == 'read/detail'" :formData="formData.holder" formKey="holder"></holder>

        <!-- 受保人 -->
        <insure :disabled="reqUrl == 'read/detail'" :formData="formData.insurce" formKey="insurce"></insure>

        <!-- 受益人 -->
        <beneficary :disabled="reqUrl == 'read/detail'" :parent="formData" :formData="formData.beneficaryList" formKey="beneficaryList"></beneficary>

        <!-- 证件信息及资料 -->
        <fileList :formData="formData" :disabled="reqUrl == 'read/detail'" />
      </template>
    </Form>

    <div class="bottom-btn">
      <Button type="primary" ghost @click="back($route.query.backUrl)">返回</Button>
      <Button v-if="reqUrl != 'read/detail'" type="primary" @click="save">确定</Button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import fromTo from './order/fromTo';
import detail from './order/detail';
import fileList from './order/fileList';
import holder from './people/holder';
import insure from './people/insure';
import beneficary from './people/beneficary';
import policyDiscount from './order/policyDiscount';
import { common } from '@/api/mixins';
import mixinParent from './mixin.parent';
import Decimal from 'decimal.js';
function getEmptyDiscountRates(defVal = '') {
  return [
    {
      year: 1,
      rate: defVal
    },
    {
      year: 2,
      rate: defVal
    },
    {
      year: 3,
      rate: defVal
    },
    {
      year: 4,
      rate: defVal
    },
    {
      year: 5,
      rate: defVal
    }
  ];
}

export default {
  mixins: [common, mixinParent],
  components: {
    fromTo,
    detail,
    holder,
    beneficary,
    fileList,
    insure,
    policyDiscount
  },
  data() {
    const dic = JSON.parse(localStorage.dic);
    return {
      policyStatus: dic['POLICY_STATUS'], // 保单状态
      themeList: dic['PRODUCT_TYPE2'], // 产品类型
      reqUrl: '',
      visible: false,
      loading: false,
      companyList: [],
      formData: null
    };
  },
  provide() {
    return {
      parent: this
    };
  },
  created() {
    const reqUrl = this.$route.query.reqUrl;
    this.reqUrl = reqUrl;
    let mode = 'edit';
    if (reqUrl === 'add') {
      mode = 'add';
    } else if (reqUrl == 'read/detail') {
      mode = 'read';
    } else if (reqUrl == 'edit') {
      mode = 'edit';
    }
    this.mode = mode;
  },
  async mounted() {
    this.id = this.$route.query.id;
    const titleMap = {
      add: '新增保单',
      'read/detail': '保单详情',
      edit: '保单编辑'
    };
    this.setPageTitle(titleMap[this.reqUrl]);
    if (this.id) {
      await this.getDetailData(this.id);
    } else {
      this.formData = {
        holder: {},
        insurce: {},
        beneficaryList: [],
        idcardHead1: [],
        idcardBack1: [],
        passportHead1: [],
        passportBack1: [],
        idcardHead2: [],
        idcardBack2: [],
        passportHead2: [],
        passportBack2: [],
        other: [],
        policyDiscount: {
          discountRates: getEmptyDiscountRates(),
          isPrePay: '0',
          discountType: '0'
        },
        payStatus: '0' // 默认未缴费
      };
    }
    this.queryCompanyList();
  },
  methods: {
    // 获取保单详情
    getDetailData(id) {
      this.$notice.showLoading();
      this.$http({
        url: '/buz/policy/read/detail',
        type: 'GET',
        data: {
          id: id
        }
      })
        .then(res => {
          this.getData(res.data);
        })
        .finally(() => {
          this.$notice.hideLoading();
        });
    },
    getData(detail) {
      console.log(detail);
      // 预约顾问
      if (detail.trInfo) {
        detail.TRName = detail.trInfo.englishName;
      }
      // 附件处理
      if (detail.attachmentInfo) {
        detail.other = JSON.parse(detail.attachmentInfo);
      } else {
        detail.other = [];
      }
      if (detail.holderAttachment) {
        const arr = JSON.parse(detail.holderAttachment);
        detail.idcardHead1 = arr.filter(item => item.type == 'idcard_head');
        detail.idcardBack1 = arr.filter(item => item.type == 'idcard_back');
        detail.passportHead1 = arr.filter(item => item.type == 'passport_head');
        detail.passportBack1 = arr.filter(item => item.type == 'passport_back');
      } else {
        detail.idcardHead1 = [];
        detail.idcardBack1 = [];
        detail.passportHead1 = [];
        detail.passportBack1 = [];
      }
      if (detail.insuranceAttachment) {
        const arr = JSON.parse(detail.insuranceAttachment);
        detail.idcardHead2 = arr.filter(item => item.type == 'idcard_head');
        detail.idcardBack2 = arr.filter(item => item.type == 'idcard_back');
        detail.passportHead2 = arr.filter(item => item.type == 'passport_head');
        detail.passportBack2 = arr.filter(item => item.type == 'passport_back');
        detail.householdRegister2 = arr.filter(item => item.type == 'household_register');
        detail.marriageCertificate2 = arr.filter(item => item.type == 'marriage_certificate');
      } else {
        detail.idcardHead2 = [];
        detail.idcardBack2 = [];
        detail.passportHead2 = [];
        detail.passportBack2 = [];
        detail.householdRegister2 = [];
        detail.marriageCertificate2 = [];
      }
      if (!detail.policyDiscount) {
        detail.policyDiscount = {};
      }
      const _discountRates = getEmptyDiscountRates();
      if (!detail.policyDiscount.discountRates) {
        detail.policyDiscount.discountRates = _discountRates;
      } else {
        const _src_discountRates = detail.policyDiscount.discountRates;
        _discountRates.forEach(item => {
          const item2 = _src_discountRates.find(item2 => item2.year == item.year);
          if (item2) {
            // item.rate = new Decimal(item2.rate).mul(100) || 0;
            item.rate = item2.rate || 0;
          } else {
            item.rate = 0;
          }
        });
        detail.policyDiscount.discountRates = _discountRates;
      }
      // detail.policyDiscount.prePayRate = new Decimal(detail.policyDiscount.prePayRate).mul(100) || 0;
      // detail.policyDiscount.prePayRate = detail.policyDiscount.prePayRate || 0;
      detail.policyDiscount.prePayRate = Array.isArray(detail.policyDiscount.prePayRate) ? detail.policyDiscount.prePayRate : []
      // 从小到大排序
      detail.policyDiscount.prePayRate.sort((a, b) => Number(a.year) - Number(b.year));
      detail.policyDiscount = Object.assign(
        {},
        {
          isPrePay: 0,
          prePayRate: 0,
          firstDuePremium: 0,
          firstPaidPremium: 0,
          firstPremiumLevy: 0
        },
        detail.policyDiscount
      );
      detail.isPrePay += '';

      detail._status = this.$units.getPolicyStatus(detail);
      this.formData = detail;

      // setTimeout(() => {
      //   this.$refs.policyDiscount && this.$refs.policyDiscount.getActivityList()
      // }, 500)
    },

    formatDate(obj, k) {
      const d = obj[k];
      if (d) {
        obj[k] = dayjs(d).format('YYYY-MM-DD');
      } else {
        obj[k] = '';
      }
    },
    // 保存
    save() {
      if (this.reqUrl == 'read/detail') return (this.visible = false);

      this.$refs.form.validate((valid, obj) => {
        if (valid) {
          if (this.loading) {
            return;
          }
          this.loading = true;
          this.$notice.showLoading();
          let formData = JSON.parse(JSON.stringify(this.formData));
          this.formatDate(formData, 'expirationDate');
          this.formatDate(formData, 'underwriteTime');
          this.formatDate(formData, 'signDate');
          this.formatDate(formData, 'payDate');
          this.formatDate(formData, 'submitAccountDate');
          this.formatDate(formData, 'refundFeeDate');
          const [status, subStatus] = formData._status.split('_');
          formData.status = status || '';
          formData.subStatus = subStatus || '';
          delete formData._status;
          this.$http({
            url: '/buz/policy/' + this.reqUrl,
            type: 'POST',
            data: formData
          })
            .then(res => {
              this.$emit('init');
              this.$notice.success('保存成功');
              this.visible = false;
            })
            .finally(() => {
              this.$notice.hideLoading();
              window.setTimeout(() => {
                this.loading = false;
              }, 300);
            });
        } else {
          this.$nextTick(() => {
            var el = document.querySelectata.policyDiscount.isPrePaor('.ivu-form-item-error');
            window.scroll({ top: el.offsetTop, behavior: 'smooth' });
          });
        }
      });
    },
    addKey(saveList, data, key, type) {
      data[key].forEach(item => {
        item.type = type;
        saveList.push(item);
      });
      delete data[key];
    },
    // 查询所有保司
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        this.companyList = res.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.main-container {
  padding-bottom: 100px;

  /deep/ .ivu-form-item-label {
    &::after {
      content: ':';
    }
  }
}

.bottom-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ccc;

  .ivu-btn {
    width: 140px;
    height: 35px;
  }

  .ivu-btn + .ivu-btn {
    margin-left: 20px;
  }
}

/deep/ .ivu-input-wrapper-disabled .ivu-input-group-append {
  border: none;
  background-color: #f4f7fa;
}
</style>
